import React, { memo } from 'react';

const WebContent = memo(({ activity }) => {
  return (
    <div className="flux-generic-content">
      <div className="flux-placeholder-bar" />
      <div className="flux-placeholder-bar short" />
      <div className="flux-placeholder-bar medium" />
      <div className="flux-placeholder-grid">
        <div className="flux-placeholder-item" />
        <div className="flux-placeholder-item" />
        <div className="flux-placeholder-item" />
      </div>
    </div>
  );
});

WebContent.displayName = 'WebContent';

export default WebContent;
